import React from 'react';

const NetWorthHouseholdFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 17.5H12C11.724 17.5 11.5 17.276 11.5 17V11C11.5 10.724 11.724 10.5 12 10.5H18C18.276 10.5 18.5 10.724 18.5 11V17C18.5 17.276 18.276 17.5 18 17.5Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M18 13H15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18 15H15" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M1 7.41404L7.61254 1.74603C8.12321 1.30829 8.87678 1.30829 9.38746 1.74603L16 7.41404"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.9286 6.51051V1.68182C14.9286 1.50099 14.8568 1.32756 14.7289 1.1997C14.6011 1.07183 14.4276 1 14.2468 1H12.2013C11.8248 1 11.5195 1.30526 11.5195 1.68182V3.58833"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.4541 15.168V10.8498C6.4541 10.4732 6.7595 10.168 7.13621 10.168H8.50041"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.07114 6.51172V15.1679" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.66667 15.6668H1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default NetWorthHouseholdFilterIcon;
